import { FC, useEffect, useState } from 'react'
import { ResultFormProps } from "../FormModel/FormStepProps";
import { UseTranslationContext } from "../Context/TranslationContext";
import { UseCodeListContext } from "../Context/CodeListContext";
import { UseSalarySimContext } from "../Context/SalarySimContext";
import { SinglePrint } from  "./SinglePrintComponent";
import SingleTablePrint from './SingleTablePrintComponent';
import { resultReadableJc } from '../Model/ResultData';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl-be';

const ResultPrint: FC = () => {
    const { currentLanguage, getKeyFromKeyId } = UseTranslationContext();
    const { getCodeListKey, codeListForm, codeListJointCommittee } = UseCodeListContext();
    const { salarySimInputMappedData, salarySimResultData, isSimpleSimulationMode } = UseSalarySimContext();
    
    const getPeriod = (month: number) => {
        if (month < 1 || month > 12) return "";
        let monthAsString = month.toString();
        let locale = currentLanguage == "nl" ? "nl-be" : currentLanguage;
        if (monthAsString.length == 1) monthAsString = "0" + monthAsString;
        var output = dayjs(`01/${monthAsString}/2000`, 'DD/MM/YYYY').locale(locale).format("MMMM");
        return output;
    };

    const getLocalizedJc = (jcTranslations: resultReadableJc) => {
        if (jcTranslations == undefined) return "";
        switch(currentLanguage) {
            case "nl":
                return jcTranslations.keyNl;
            case "fr":
                return jcTranslations.keyFr;
            case "en":
            default:
                return jcTranslations.keyX;
        }
    };

    const hasDependents = () =>
        (salarySimInputMappedData.nb_enfants_charge +
        salarySimInputMappedData.nb_autres_personnes_charge +
        salarySimInputMappedData.nb_autres_personnes_plus65_charge +
        salarySimInputMappedData.nb_plus65_situation_dependance) > 0;
    
    const convertFromMinutes = (baseMinutes: number) => {
        if (isNaN(baseMinutes)) return "00:00";
        let hours = Math.floor(baseMinutes / 60).toString();
        let minutes = (baseMinutes % 60).toString();
        let hoursMin = (((hours.length <= 1)?"0"+ hours:hours ) + ":" + ((minutes.length <= 1)? "0" + minutes:minutes));
        return hoursMin;
    };

    const GenerateR6SOnssInfo = () => {

        var messageInfo = getKeyFromKeyId("REMARQUE_ONSS");
        var hh = salarySimResultData.R6S / 60;
        var mm = salarySimResultData.R6S % 60;
        var hhmm = hh + ":" + mm;

        messageInfo = messageInfo.replace("#jours#",salarySimResultData.R6R.toString());
        messageInfo = messageInfo.replace("#heures#",hhmm);

        return messageInfo;
    }


    const getDayKey = (index: number) => ["LU", "MA", "ME", "JE", "VE", "SA", "DI"][(index < 7 && index >= 0) ? index : 6];

    return(
        <>
        <div aria-hidden="true" className="details-print">
            <h3 className="sous-titre">{getKeyFromKeyId("DETAILS")}</h3>
            <div className="section-details">
                <SinglePrint label={getKeyFromKeyId("NOM")} data={salarySimInputMappedData.nom}/>
                <SinglePrint label={getKeyFromKeyId("PERIODE")} data={getPeriod(salarySimInputMappedData.mois_periode_paie)}/>
                <SinglePrint label={getKeyFromKeyId("BIRTHDATE")} data={salarySimInputMappedData.Date_Naissance.format('DD/MM/YYYY')}/>
                <SinglePrint label={getKeyFromKeyId("ETAT_CIVIL")} data={getCodeListKey("ETAT_CIVIL_IBRUNET", salarySimInputMappedData.cd_etat_civil)}/>
                <SinglePrint label={getKeyFromKeyId("UNITE_ETABLISSEMENT")} data={getCodeListKey("IBRUNET_UNITE_LOCALE", salarySimInputMappedData.No_Unite_Locale)}/>
                <SinglePrint label={getKeyFromKeyId("APPOINTMENT_TYPE")} data={getCodeListKey("IBRUNET_CD_ENGAGEMENT", salarySimInputMappedData.Scenario_1er_Engage)}/>
                <SinglePrint label={getKeyFromKeyId("DISABLED_PERSON")} data={getKeyFromKeyId(salarySimInputMappedData.cd_handicape == 1 ? "OUI" : "NON")}/>
                <SinglePrint label={getKeyFromKeyId("CONJOINT")} data={getCodeListKey("CONJOINT_IBRUNET", salarySimInputMappedData.cd_conjoint)}/>
                <SinglePrint label={getKeyFromKeyId("SPOUSE_DISABLED66")} data={getKeyFromKeyId(salarySimInputMappedData.cd_conjoint_handicape == 1 ? "OUI" : "NON")}/>

                {/* CREATE LIST OF DEPENDENTS IF ANY */}

                <SinglePrint label={getKeyFromKeyId("PERSONNE_CHARGES")} data={getKeyFromKeyId(hasDependents() ? "OUI" : "NON")}/>
                
                {/*CHILDREN */ }
                <SinglePrint label={""} data={""}/>

                {salarySimInputMappedData.nb_enfants_charge > 0 &&
                    <SinglePrint label={getKeyFromKeyId("CHILDREN")} data={salarySimInputMappedData.nb_enfants_charge}/>
                }
                {salarySimInputMappedData.nb_enfants_handicapes_charge > 0 &&
                    <SinglePrint label={getKeyFromKeyId("LABEL_HANDICAPPED")} data={salarySimInputMappedData.nb_enfants_handicapes_charge}/>
                }

                {/*SUB 65 dependents */ }
                {salarySimInputMappedData.nb_autres_personnes_charge > 0 &&
                    <SinglePrint label={getKeyFromKeyId("DEPENDENT_SUB65")} data={salarySimInputMappedData.nb_autres_personnes_charge}/>
                }
                {salarySimInputMappedData.nb_autres_personnes_handicapees_charge > 0 &&
                    <SinglePrint label={getKeyFromKeyId("LABEL_HANDICAPPED")} data={salarySimInputMappedData.nb_autres_personnes_handicapees_charge}/>
                }

                {/* 65 + */ }
                {salarySimInputMappedData.nb_autres_personnes_plus65_charge > 0 &&
                    <SinglePrint label={getKeyFromKeyId("DEPENDENT_PAST65")} data={salarySimInputMappedData.nb_autres_personnes_plus65_charge}/>
                }
                {salarySimInputMappedData.nb_autres_personnes_plus65_handicapees_charge > 0 &&
                    <SinglePrint label={getKeyFromKeyId("LABEL_HANDICAPPED")} data={salarySimInputMappedData.nb_autres_personnes_plus65_handicapees_charge}/>
                }

                {/* dependency 65+ */ }
                {salarySimInputMappedData.nb_plus65_situation_dependance > 0 &&
                    <SinglePrint label={getKeyFromKeyId("DEPENDENT_PAST65_DEPENDENCY")} data={salarySimInputMappedData.nb_plus65_situation_dependance}/>
                }

                {/*------------------------------------*/}
                <SinglePrint label={""} data={""}/>

                <SinglePrint label={getKeyFromKeyId("TYPE_CONTRAT")} data={getCodeListKey((isSimpleSimulationMode ? "TYPE_CONTRAT_IBRUNET": "TYPE_CONTRAT_IBRUNET_PLUS"), salarySimInputMappedData.cd_type_contrat)}/>
                <SinglePrint label={getKeyFromKeyId("SOUMIS_ONSS")} data={getKeyFromKeyId(salarySimInputMappedData.cd_soumis_onss == 1 ? "OUI" : "NON")}/>
                { salarySimResultData != undefined && isSimpleSimulationMode == false &&
                    <SinglePrint label={getKeyFromKeyId("COM_PARITAIRE")} data={getLocalizedJc(salarySimResultData.ReadableJc)}/>
                }
                
                { !isSimpleSimulationMode &&
                    <SinglePrint label={getKeyFromKeyId("EFFECTIF_EMPL")} data={getCodeListKey("EFFECTIF_EMPL_IBRUNET_PLUS", salarySimInputMappedData.cd_effectif_employeur)}/>
                }
                
                <SingleTablePrint label={getKeyFromKeyId("HORAIRE_TRAVAILLEUR")} tableId="regimeWorker" data={salarySimInputMappedData.regime_horaire.map((element, index) => ({ label: getKeyFromKeyId(getDayKey(index)), data: convertFromMinutes(element) }))} />
                <SingleTablePrint label={getKeyFromKeyId("HORAIRE_REFERENCE")} tableId="regimeEmpl" data={salarySimInputMappedData.regime_horaire_emp.map((element, index) => ({ label: getKeyFromKeyId(getDayKey(index)), data: convertFromMinutes(element) }))} />
                
                <SinglePrint label={getKeyFromKeyId("CALCULATION_DIRECTION")} data={getKeyFromKeyId(salarySimInputMappedData.net == 0 ? "BRUT" : "NET")}/>
                <SinglePrint label={`${getKeyFromKeyId("AMOUNT_MONTHLY")} (${getKeyFromKeyId("MANDATORY_FIELD")})`} data={salarySimInputMappedData.net == 0 ? salarySimInputMappedData.brut : salarySimInputMappedData.net}/>
                <SinglePrint label={getKeyFromKeyId("MONTANT_IMPOSABLE_PP_ORDINAIRE")} data={salarySimInputMappedData.Montant_Imposable_Pp_Ordinaire}/>
                <SinglePrint label={getKeyFromKeyId("BENEFITS_KIND_NET")} data={salarySimInputMappedData.avantages_nature}/>
                <SinglePrint label={getKeyFromKeyId("BENEFITS_CAR_NET")} data={salarySimInputMappedData.avantages_nature_voiture}/>
                <SinglePrint label={getKeyFromKeyId("AVEC_AVANTAGE_DOM_TRAVAIL")} data={getKeyFromKeyId(salarySimInputMappedData.Sans_Avantage_Domicile_Travail ? "NON" : "OUI")}/>
                {/* <SinglePrint label={getKeyFromKeyId("BENEFITS_WORKER_INSUR_NET")} data={`DATA ${getKeyFromKeyId("BENEFITS_WORKER_INSUR_NET")}`}/> */}
                <SinglePrint label={`${getKeyFromKeyId("BENEFITS_OTHERS_NET")} (${getKeyFromKeyId("NEGATIVE")})`} data={salarySimInputMappedData.divers_net_neg}/>
                <SinglePrint label={`${getKeyFromKeyId("BENEFITS_OTHERS_NET")} (${getKeyFromKeyId("POSITIVE")})`} data={salarySimInputMappedData.divers_net_pos}/>
                <SinglePrint label={`${getKeyFromKeyId("BONUS_CURRENT")} - ${getKeyFromKeyId("DOUBLE_PEC")}`} data={salarySimInputMappedData.pecule_vacances}/>
                <SinglePrint label={`${getKeyFromKeyId("BONUS_CURRENT")} - ${getKeyFromKeyId("COMPL_PEC_4S")}`} data={salarySimInputMappedData.complement_pecule_vacances}/>
                <SinglePrint label={`${getKeyFromKeyId("BONUS_PREVIOUS")} - ${getKeyFromKeyId("SIMPLE_PEC")}`} data={salarySimInputMappedData.simple_pecule}/>
                <SinglePrint label={`${getKeyFromKeyId("BONUS_PREVIOUS")} - ${getKeyFromKeyId("DOUBLE_PEC")}`} data={salarySimInputMappedData.double_pecule}/>
                <SinglePrint label={`${getKeyFromKeyId("BONUS_PREVIOUS")} - ${getKeyFromKeyId("COMPL_PEC")}`} data={salarySimInputMappedData.complement_pecule}/>
                <SinglePrint label={`${getKeyFromKeyId("BONUS_NEXT")} - ${getKeyFromKeyId("SIMPLE_PEC")}`} data={salarySimInputMappedData.simple_pecule_anticipe}/>
                <SinglePrint label={`${getKeyFromKeyId("BONUS_NEXT")} - ${getKeyFromKeyId("DOUBLE_PEC")}`} data={salarySimInputMappedData.double_pecule}/>
                <SinglePrint label={`${getKeyFromKeyId("BONUS_NEXT")} - ${getKeyFromKeyId("COMPL_PEC")}`} data={salarySimInputMappedData.complement_pecule_anticipe}/>
                <SinglePrint label={getKeyFromKeyId("ABON_SOCIAL_PUBLIC")} data={salarySimInputMappedData.abonnement_social}/>
                <SinglePrint label={getKeyFromKeyId("ABON_SOCIAL_PRIVE")} data={salarySimInputMappedData.frais_deplacement}/>
                <SinglePrint label={getKeyFromKeyId("ASSURANCE_GROUPE_EMPL")} data={salarySimInputMappedData.assurance_groupe_empl}/>
                
                { salarySimInputMappedData.cd_type_contrat == 675 &&
                    <>
                        <SinglePrint label={`${getKeyFromKeyId("PRIME_FIN_ANNEE")} ${getKeyFromKeyId("SOUMISE")}`} data={salarySimInputMappedData.Prime_Fin_Annee_Forem_Soumise}/>
                        <SinglePrint label={`${getKeyFromKeyId("PRIME_FIN_ANNEE")} ${getKeyFromKeyId("NON_SOUMISE")}`} data={salarySimInputMappedData.Prime_Fin_Annee_Forem_Non_Soumise}/>
                    </>
                }

                { salarySimInputMappedData.cd_type_contrat != 675 &&
                    <SinglePrint label={getKeyFromKeyId("PRIME_FIN_ANNEE")} data={salarySimInputMappedData.prime_fin_annee}/>
                }
                <SinglePrint label={getKeyFromKeyId("BENEFITS_WORKER_INSUR_NET")} data={salarySimInputMappedData.mt_cot_empl_assurance_groupe}/>
                <SinglePrint label={getKeyFromKeyId("REMUN_NON_PER")} data={salarySimInputMappedData.remuneration_non_periodique}/>
                <SinglePrint label={getKeyFromKeyId("DROITS_AUTEUR")} data={salarySimInputMappedData.Droits_Auteur}/>
            </div>
        </div>
        </>
    );
}

export default ResultPrint;